<template>
  <section class="relative overflow-hidden pb-16 pt-32 sm:pb-24 sm:pt-40">
    <div class="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-gradient-end/5 dark:from-accent/10 dark:to-gradient-end/10" />
    <div class="absolute right-0 top-1/4 size-[28rem] rounded-full bg-gradient-to-r from-accent/25 to-gradient-end/25 blur-3xl" />

    <div class="container relative mx-auto">
      <div class="grid items-center gap-16 lg:grid-cols-2">
        <div class="animate-slide-up text-center lg:text-left">
          <div class="mb-6 inline-flex items-center rounded-full border border-accent/20 bg-accent/10 px-4 py-2 dark:border-accent/30">
            <span class="mr-3 size-2 animate-pulse-slow rounded-full bg-accent" />
            <span class="text-sm font-medium text-accent">Available for new projects</span>
          </div>

          <h1 class="text-4xl font-bold leading-tight text-ternary-dark dark:text-primary-light sm:text-5xl xl:text-6xl">
            Web and mobile products,
            <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">built to last</span>
          </h1>

          <p class="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-gray-600 dark:text-gray-300 lg:mx-0 xl:text-xl">
            Vedware is a small senior team with 20+ years of experience. We design and build websites, web apps, APIs and iOS/Android apps, and ship our own apps too.
          </p>

          <div class="mt-8 flex flex-col items-center gap-4 sm:flex-row lg:justify-start">
            <Btn to="/projects" class="bg-gradient-to-r from-accent to-gradient-end transition-all duration-300 hover:shadow-glow">
              View Our Work
            </Btn>
            <Btn to="/contact" color="gray">
              Get In Touch
            </Btn>
          </div>
        </div>

        <!-- Real app screens: tilt + parallax layers -->
        <div class="mx-auto w-full max-w-md [perspective:1000px]" aria-hidden="true">
          <div ref="stage" class="flex justify-center will-change-transform [transform-style:preserve-3d]">
            <div
              v-for="(shot, index) in shots"
              :key="shot.src"
              class="w-1/2"
              :data-depth="index === 0 ? 1 : 1.8"
            >
              <div class="animate-float" :style="{ animationDelay: `${index * 1.5}s` }">
                <PhoneFrame :class="index === 0 ? '-rotate-6 translate-y-6' : 'rotate-6 -translate-x-4 -translate-y-4'">
                  <img
                    :src="shot.src"
                    :alt="shot.alt"
                    width="604"
                    height="1312"
                    fetchpriority="high"
                    class="block w-full"
                  >
                </PhoneFrame>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Btn from '~/components/UI/Btn.vue'
import PhoneFrame from '~/components/UI/PhoneFrame.vue'
import { useTilt } from '~/composables/useTilt'
import { apps } from '~/utils/projects'

// Second screenshot of each app (first is the banner)
const stage = ref<HTMLElement | null>(null)
useTilt(stage)

const shots = apps.slice(0, 2).map(app => app.images[1]!).filter(Boolean)
</script>
